import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// TODO: Consider adding a search bar or sitemap link to help users find content

console.log('[DEBUG NotFoundPage] Component loaded');

const NotFoundPage = () => {
  console.log('[DEBUG NotFoundPage] Rendering 404 page');

  return (
    <>
      <Helmet>
        <title>Page Not Found | DD Construction</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Container
        className="text-center py-5"
        style={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <h1 style={{ fontSize: '4rem', fontWeight: 'bold', color: '#A52A2A' }}>404</h1>
        <h2 className="mb-3">Page Not Found</h2>
        <p className="text-muted mb-4">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div>
          <Button as={Link} to="/" variant="dark" size="lg">
            Back to Home
          </Button>
        </div>
      </Container>
    </>
  );
};

export default NotFoundPage;
